<template>
  <div>
    <v-dialog v-model="deleteDialog" max-width="450px">
      <DeleteModal
          title="Deletar"
          textMessage="Tem certeza que deseja deletar esse sku?"
          cancelBtn="Cancelar"
          okbtn="Deletar"
          textObservation=""
          @close="(deleteDialog = false), updateList()"
          @action="(deleteDialog = false), remove()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-model="editResaleStockDialog"
        max-width="1000"
    >
      <EditResaleStock
          v-if="editResaleStockDialog"
          :resaleproductskuFilter="resaleproductskuFilter"
          @close="close"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="removeProducts()"
      />
    </v-dialog>

    <HeaderResale
        :arrow="true"
        :title="title"
        @voltar="voltarRevendas()"
        :haveAction="false"
    />

    <v-container
        style="max-width: unset; background: #e5e5e5"
        class="pa-2"
    >
      <v-card
          transition="scale-transition"
          class="header-card pa-0"
          elevation="0"
      >
        <v-row class="ma-0">
          <v-col cols="12" md="2" sm="2">
            <div>
              <v-img
                  :src="
                  currentResale.image
                    ? env_url + currentResale.image
                    : require('../../../../assets/fotoDefault.svg')
                "
                  alt="profilePicture"
                  cover
                  style="border-radius: 10px"
                  class="imgProduct"
                  max-height="140"
                  min-height="125"
              ></v-img>
            </div>
          </v-col>

          <v-col
              class="d-flex flex-column justify-space-between"
              cols="12"
              md="4"
              sm="4"
          >
            <div>
              <span class="main-title">
                {{ this.currentResale.name }}
              </span>

              <br/>

              <span class="main-subtitle">
                {{ this.currentResale.neighborhood }},
                {{ this.currentResale.city }}
              </span>
            </div>

            <div>
              <div class="d-flex align-center mb-2">
                <span class="date-title mr-2">Cadastro: </span>

                <span class="date">
                  {{ formatDate(this.currentResale.created_at) }}</span
                >
              </div>

              <div class="d-flex align-center">
                <span class="date-title mr-2">Ultimo Acesso: </span>

                <span class="date">{{
                    formatDate(this.currentResale.last_sign)
                  }}</span>
              </div>
            </div>
          </v-col>

          <v-col
              class="d-flex flex-column justify-space-around"
              cols="12"
              md="2"
              sm="2"
          >
            <v-select
                style="border-radius: 10px; max-width: 130px"
                hide-details
                color="normalred"
                outlined
                append-icon="mdi-chevron-down"
                v-model="currentResale.status"
                height="40"
                dense
                @change="changeStatus"
                :items="status"
                item-text="label"
                item-value="value"
                required
            ></v-select>

            <div class="align-center">
              <label class="mt-2">Reputação do revendedor</label>
              <v-rating
                  v-model="currentResale.reputationStars"
                  bg-color="orange-lighten-1"
                  color="normalred"
                  clearable
                  @input="changeFavorite()"
              ></v-rating>
            </div>
          </v-col>

          <v-col
              class="d-flex flex-column justify-space-around align-center"
              cols="12"
              md="4"
              sm="4"
          >
            <div class="labelR">{{ shoppingSales }} vendas mensais</div>

            <div class="labelR2">{{ activeSKU }} SKUs</div>

            <div class="labelR">{{ totalSales }} vendas totais</div>

            <div>
              <v-btn
                  @click="dadoVendasCompletar()"
                  elevation="0"
                  color="#FFFFFF"
                  style="
                  font-family: Roboto;
                  font-style: normal;
                  font-weight: bold;
                  font-size: 13px;
                  line-height: 124%;
                  color: #bc0000;
                  border: 2px solid #bc0000;
                  box-sizing: border-box;
                  border-radius: 8px;
                "
              ><span> Dados de vendas completos </span>
              </v-btn>
            </div>
          </v-col>

          <div class="p-2"></div>
        </v-row>
      </v-card>

      <v-tabs
          background-color="#ECEEF1"
          grow
          height="55"
          hide-slider
          v-model="activeTab"
      >
        <v-tab
            :value="0"
            active-class="active-tab"
            class="tab"
            style="font-weight: bold !important"
            @click="setActiveTab(0)"
        >
          <span>Histórico de vendas</span>
        </v-tab>

        <v-tab
            :value="1"
            active-class="active-tab"
            class="tab"
            @click="setActiveTab(1)"
        >
          <span>Produtos em Estoque</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items
          v-model="activeTab"
          style="border-radius: 6px"
      >
        <v-tab-item :value="0">
          <!-- Tabela1 -->
          <v-data-table
              ref="table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum pedido encontrado"
              :headers="headers"
              :items="orders"
              class="elevation-1 mytable"
              style="cursor: pointer"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              @click:row="handleRowClick"
              :key="componentKey"
          >
            <template v-slot:[`item.created_at`]="{ item }">
              <span>
                {{ formatDate(item.created_at) }}
              </span>
            </template>

            <template v-slot:[`item.totalPrice`]="{ item }">
              <span>
                {{
                  item.totalPrice.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </template>

            <template
                v-slot:[`item.orderStatus`]="{ item }"
                cols="12"
                md="6"
                xs="12"
                sm="12"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      style="border-radius: 12px"
                      :class="
                      item.orderStatus === 0
                        ? 'novo'
                        : item.orderStatus === 1
                        ? 'aguardando'
                        : item.orderStatus === 3 ||
                          item.orderStatus === 6 ||
                          item.orderStatus === 10
                        ? 'enviado'
                        : item.orderStatus === 4 || item.orderStatus === 9
                        ? 'enviado'
                        : item.orderStatus === 7 ||
                          item.orderStatus === 5 ||
                          item.orderStatus === 2
                        ? 'devolvido'
                        : 'entregue'
                    "
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon style="font-size: 15px"
                    >{{
                        statusList.find((x) => x.value === item.orderStatus).label
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{
                    statusList.find((x) => x.value === item.orderStatus).label
                  }}</span>
              </v-tooltip>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0 pb-1 mx-2">
                <Pagination
                    v-if="totalItems > pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="page"
                    :pageSize="pageSize"
                    :totalPages="totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="1" class="pb-4">
          <v-card class="pa-2 mt-0" elevation="0">
            <v-row cols="12">
              <v-col xs="12" sm="12" md="12" lg="9" xl="9">
                <v-text-field
                    outlined
                    class="px-0"
                    style="
                border: 1px solid #979797;
                border-radius: 7.5px;
                width: 100%;
              "
                    color="black"
                    background-color="#F5F5F5"
                    hide-details
                    @keydown="updateList"
                    placeholder="Nome do Produto"
                    v-model="filterSkusResale.ProductName"
                    attach
                    :loading="loading"
                >
                  <template v-slot:append>
                    <v-icon
                        @click="updateList()"
                        class="pt-0"
                        color="normalred"
                        size="26"
                    >
                      mdi-magnify
                    </v-icon>
                  </template>
                </v-text-field>

              </v-col>

              <v-col xs="12" sm="12" md="12" lg="3" xl="3">
                <v-btn
                    block
                    dark
                    elevation="0"
                    height="56"
                    class="add-button mb-3"
                    @click="addProduct()"
                >
                  Adicionar produto
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <v-data-table
              id="product-profile-table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum produto encontrado"
              :headers="productHeaders"
              :items="filteredProducts"
              class="elevation-0"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              :key="componentKey"
              v-model="selectedProdcts"
              show-select
              item-key="id"
              :single-select="false"
          >
            <template v-slot:[`item.productSku.product.productPic`]="{ item }">
              <div class="d-flex pa-3">
                <v-img
                    :src="item.productSku.product.productPic"
                    :alt="item.productName"
                    class="imgProduct"
                    width="80"
                    height="50"
                ></v-img>
              </div>
            </template>

            <template v-slot:[`item.productSku.sku`]="{ item }">
              <span class="product-name-field">
                {{
                  item.productSku &&
                  item.productSku.attributes &&
                  item.productSku.attributes.length > 0
                      ? item.productSku.attributes[0].name
                      : "Sem registro"
                }}
              </span>
            </template>

            <template v-slot:[`item.productSku.maximumPrice`]="{ item }">
              <span class="product-name-field">
                {{
                  item.productSku.maximumPrice.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </template>


            <template v-slot:[`item.productSku.minimumPrice`]="{ item }">
              <span class="product-name-field">
                {{
                  item.productSku.minimumPrice.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </template>

            <template v-slot:[`item.productSku.differentValue`]="{ item }">
              <span class="product-name-field">
                {{
                  item.productSku.differentValue.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </template>

            <template v-slot:[`item.price`]="{ item }">
              <span class="product-name-field">
                {{
                  item.price.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      fab
                      tile
                      small
                      class="ma-1 table-button mr-3"
                      @click="editProduct(item)"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      fab
                      tile
                      small
                      class="ma-1 remove-button"
                      color="red"
                      @click="deleteProduct(item)"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon dark>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>

            <template v-slot:header.data-table-select="{ on, props}">
              <v-simple-checkbox
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
                  :ripple="false"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
              <v-simple-checkbox
                  :ripple="false"
                  @click="addProductListSelectedProdcts(item)"
                  :value="isSelected"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:footer >
              <section class="ma-0 pa-0 pb-1 mx-2">
                <Pagination
                    v-if="totalItemsSkusResale > pageSizeSkusResale"
                    :currentPage="currentPageSkusResale"
                    :totalItems="totalItemsSkusResale"
                    :page="pageSizeSkusResale"
                    :pageSize="pageSizeSkusResale"
                    :totalPages="totalPagesSkusResale"
                    @back-page="backPageSkusResale"
                    @next-page="nextPageSkusResale"
                >
                </Pagination>
              </section>

              <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedProdcts.length > 0">
                <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <label>Selecione a ação</label>
                  <v-select
                      class="ma-0 pa-0 "
                      dense
                      v-model="actionSelected"
                      outlined
                      style="border-radius: 3px!important"
                      :items="actions"
                      item-text="label"
                      item-value="value"
                      placeholder="Selecione a ação"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
                  <v-btn
                      class="secondary-button mt-5 ml-3"
                      style="height: 40px!important; border-radius: 7.5px!important"
                      height="40"
                      width="100%"
                      elevation="0"
                      :disabled="!actionSelected"
                      @click="confirmActionDialog = true"
                  >
                    {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<style scoped>
.add-button {
  transition: 0.3s;
  font-weight: bold !important;
  font-size: 16px !important;
  color: #ffffff !important;
  background: #bc0000 !important;
  border-radius: 7.5px !important;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.imgProduct {
  background-position: center center;
  border-radius: 10px;
}

.novo {
  width: 120px !important;
  height: 30px !important;
  background: #979797 !important;
  border-radius: 5px !important;
  color: white !important;
  font-style: normal;
  font-weight: 500;
  font-size: 151px !important;
}

.aguardando {
  width: 120px !important;
  height: 30px !important;
  color: orange !important;
  border: 1px solid orange !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.aprovado {
  width: 120px !important;
  height: 30px !important;
  color: #fee853 !important;
  border: 1px solid #fee853;
  box-sizing: border-box !important;
  border-radius: 10px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 3px !important;
}

.entregue {
  width: 120px !important;
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.enviado {
  width: 120px !important;
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.devolvido {
  width: 120px !important;
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.cancelado {
  width: 120px !important;
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.main-title {
  font-weight: bold;
  font-size: 25px;
  line-height: 35px;

  color: #000000;
}

.main-subtitle {
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #5f6368;
}

.date-title {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #333333;
}

.date {
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #333333;
}

.header-card {
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
  border-radius: 6px;
}

.labelR {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #bc0000;
}

.labelR2 {
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 30px;
  text-align: center;

  color: #2d3038;
}

p {
  font-weight: bold;
}

.flex-end {
  justify-content: flex-end;
}

.black--text /deep/ label {
  color: black;
  font-size: 13px;
}

.remove-button {
  border: 1px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
  border-radius: 4px
}

.table-button:hover {
  background: #2d3038 !important;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
  tbody
  tr:not(:last-child)
  td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import HeaderResale from "../components/HeaderResale.vue";
import EditResaleStock from "./EditResaleStock.vue";
import Vue from "vue";
import DeleteModal from "@/views/pages/components/DeleteModal.vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "Register",

  props: {
    product: Object,
  },

  components: {
    ConfirmModal,
    Pagination,
    DeleteModal,
    HeaderResale,
    EditResaleStock,
  },

  data: () => ({
    selectedProdcts: [],
    actions: [
      { label: "Excluir Produtos(s)", value: 1},
    ],
    actionSelected: null,
    confirmActionDialog: false,
    activeTab: 0,
    editResaleStockDialog: false,
    deleteDialog: false,
    closeNoLoading: false,
    title: "",
    shoppingSales: 0,
    activeSKU: 0,
    totalSales: 0,
    componentKey: 1,
    products: [],
    filteredProducts: [],
    orders: [],
    active: true,
    statusList: [
      {label: "Novo", value: 0},
      {label: "Aguardando", value: 1},
      {label: "Reprovado", value: 2},
      {label: "Aprovado", value: 3},
      {label: "Enviado", value: 4},
      {label: "Devolvido", value: 5},
      {label: "Separando", value: 6},
      {label: "Cancelado", value: 7},
      {label: "Entregue", value: 8},
      {label: "Retirar", value: 9},
      {label: "Etiqueta", value: 10},
    ],
    status: [
      {label: "Ativo", value: 1},
      {label: "Inativo", value: 0},
    ],
    headers: [
      {
        text: "Pedido",
        align: "center",
        class: "item",
        value: "orderCode",
      },
      {
        text: "Data de compra",
        class: "item",
        value: "created_at",
        align: "center",
      },
      {
        text: "Cliente",
        class: "item",
        value: "client.name",
        align: "center",
        sortable: false,
      },
      {
        text: "Total",
        class: "item",
        value: "totalPrice",
        align: "center",
      },
      {
        text: "Status",
        class: "item",
        value: "orderStatus",
        align: "center",
      },
    ],
    productHeaders: [
      {
        text: "Código",
        class: "item",
        value: "productSku.product.productCode",
        align: "start",
        sortable: false,
      },
      {
        text: "Foto",
        class: "item",
        value: "productSku.product.productPic",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        align: "center",
        value: "productSku.product.productName",
      },
      {
        text: "Sku",
        align: "center",
        value: "productSku.sku",
        sortable: false,
      },
      {
        text: "Preço máximo (Imprimax)",
        class: "item",
        align: "center",
        sortable: false,
        value: "productSku.maximumPrice",
      },
      {
        text: "Preço mínimo (Imprimax)",
        class: "item",
        align: "center",
        sortable: false,
        value: "productSku.minimumPrice",
      },
      {
        text: "Preço (Imprimax)",
        class: "item",
        align: "center",
        sortable: false,
        value: "productSku.differentValue",
      },
      {
        text: "Preço (Revendedor)",
        class: "item",
        align: "center",
        sortable: false,
        value: "price",
      },
      {
        text: "QTD.",
        class: "item",
        align: "center",
        sortable: false,
        value: "quantity",
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    dialogKey: false,
    page: 1,
    pageSize: 15,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    filter: {
      page: 1,
      pageSize: 15,
    },
    pageSizeOrder: 15,
    pageSkusResale: 1,
    pageSizeSkusResale: 15,
    totalPagesSkusResale: 1,
    totalItemsSkusResale: 1,
    currentPageSkusResale: 1,
    filterSkusResale: {
      ProductName: null,
      page: 1,
      pageSize: 15,
      resaleId: null,
    },
    loading: false,
    apiService: new ApiService(),
    resaleproductskuFilter: null,
    resales: [],
    currentResale: {
      reputationStars: 0
    },
    env_url: "",
    currentUser: {},
    currentProduct: {},
  }),

  async created() {
    await this.updateResale();
    const jsonFiltersOrder =  JSON.parse(localStorage.getItem("filters-resale-profile-order"));
    if (jsonFiltersOrder && jsonFiltersOrder.page && jsonFiltersOrder.ResaleId && jsonFiltersOrder.ResaleId === this.resaleId) {
      this.filter = jsonFiltersOrder
      this.page = jsonFiltersOrder.page
    }
    const jsonFilters =  JSON.parse(localStorage.getItem("filters-resale-profile"));

    if (jsonFilters && jsonFilters.page && jsonFilters.resaleId && jsonFilters.resaleId === this.resaleId) {
      this.filterSkusResale = jsonFilters
      this.pageSkusResale = jsonFilters.page
    }

    const jsonActiveTab =  Number(localStorage.getItem("filters-resale-profile-activeTab"));
    this.activeTab = jsonActiveTab
    await this.updateList();
    await this.updateResaleOrders();
    this.env_url = process.env.VUE_APP_BASE_URL;
    this.title = "Revendedores - " + this.currentResale.name;
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  computed: {},

  methods: {
    removeProducts(){
      try {
        this.selectedProdcts.forEach((product) => {
          product.doneByAdminOrMasterUser = true
        })
        this.confirmActionDialog = false;
        this.apiService.post('resaleproductsku/delete/list', this.selectedProdcts).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Produtos excluídos com sucesso",
            trace: null,
          });
          await this.updateList()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir os produtos",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addProductListSelectedProdcts(product){
      const productFind = this.selectedProdcts.findIndex((x) => x.id === product.id)
      if (productFind > -1) {
        this.selectedProdcts.splice(productFind, 1)
      } else {
        this.selectedProdcts.push(product)
      }
    },

    setActiveTab(activeTab) {
      this.activeTab = activeTab;
      localStorage.setItem("filters-resale-profile-activeTab", JSON.stringify(this.activeTab));
    },

    async remove() {
      this.loading = true;
      const doneByAdminOrMasterUser = true;
      await this.apiService
          .delete(`resaleproductsku/delete/${this.currentProduct.id}/${this.resaleId}/${doneByAdminOrMasterUser}`)
          .then(() => {
            this.updateList();
            this.loading = false;
            this.deleteDialog = false;
          })
          .catch(() => {
            this.loading = false;
            this.deleteDialog = false;
          });
    },

    async addProduct() {
      localStorage.setItem("filters-resale-profile", JSON.stringify(this.filterSkusResale));
      await this.$router.push({
        path:'product-select',
        query: {resaleId: this.currentResale.id},
      });
    },

    async editProduct(item) {
      this.resaleproductskuFilter = {
        productId: item.productSku.productId,
        userId: item.resaleId,
        resaleId: item.resaleId,
        productSkuId: item.productSku.id
      };
      setTimeout(() => {
        this.editResaleStockDialog = true;
      }, 100)

    },

    deleteProduct(item) {
      this.currentProduct = item;
      this.deleteDialog = true;
    },

    filterProducts() {
      this.filteredProducts = this.products.filter((item) =>
          item.productSku.product.productName
              .toLowerCase()
              .includes(this.filterSkusResale.ProductName)
      );
    },

    async handleRowClick(item) {
      localStorage.setItem("filters-resale-profile-order", JSON.stringify(this.filter));
      await this.$router.push({
        path: `/order-detail?id=${item.id}&breadcrumbs=1`,
        params: item,
      });
    },

    async changeStatus() {
      this.loading = true;

      this.apiService
          .post("resale/changeStatus", this.currentResale)
          .then(() => {
            this.loading = false;
          })
          .catch(async (err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível mudar a status da revenda",
              message: err.body.message,
              trace: null,
            });
            await this.updateResale();
            this.loading = false;
          });
    },

    changeFavorite() {
      this.apiService
          .post("resale/changeReputation", this.currentResale)
          .then((response) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Não foi possível mudar a status da revenda",
              message: response.message,
              trace: null,
            });
          })
          .catch(() => {

          });
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    save(date) {
      this.$refs.menu.save(date);
    },

    async close() {
      this.editResaleStockDialog = false
      await this.updateList()
    },

    voltarRevendas() {
      this.$router.push("/resales");
    },

    dadoVendasCompletar() {
      this.$router.push("/orders");
    },

    async updateList() {
      this.loading = true;
      this.resaleId = this.$route.query.id;
      this.filterSkusResale.resaleId = this.resaleId;
      await this.apiService
          .post(`resaleproductsku/skus-resale`, this.filterSkusResale)
          .then((response) => {
            this.totalPagesSkusResale = response.pager.totalPages;
            this.totalItemsSkusResale = response.pager.totalItems;
            this.currentPageSkusResale = response.pager.currentPage;
            this.products = response.resaleProducts;
            this.filteredProducts = response.resaleProducts;
            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro listar produtos",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });

      await this.apiService
          .post(`attribute/list`, this.filter)
          .then((response) => {
            this.productAttributes = response.attributes;
          });

      await this.apiService
          .post(`attributesgroup/list`, this.filter)
          .then((response) => {
            this.productAttributesGroup = response.attributesGroups;
          });

      this.componentKey += 1;
    },

    async backPageSkusResale() {
      this.filterSkusResale.page -= 1;
      this.pageSizeSkusResale = this.filterSkusResale.page;
      await this.updateList();
    },

    async nextPageSkusResale() {
      this.filterSkusResale.page += 1;
      this.pageSkusResale = this.filterSkusResale.page;
      await this.updateList();
    },

    async updateResale() {
      this.loading = true;
      this.resaleId = this.$route.query.id;
      await this.apiService
          .get(`resale/getprofileresale?id=` + this.resaleId)
          .then((response) => {
            this.currentResale = response.content.resale;
            this.activeSKU = response.content.activeSKU;
            this.shoppingSales = response.content.shoppingSales;
            this.totalSales = response.content.totalSales;
            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro listar produtos",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });
    },

    async getClientbyId(id) {
      try {
        return await this.apiService.get(`user/get-one?id=` + id)
      } catch (e) {

      }

    },

    async updateResaleOrders() {
      this.resaleId = this.$route.query.id;
      this.filter.ResaleId = this.currentResale.id;
      await this.apiService
          .post(`order/list`, this.filter)
          .then(async (response) => {
            this.orders = response.orders;
            for (const order of this.orders) {
              if (!order.client) {
                order.client = await this.getClientbyId(order.clientId)
              }
            }
            this.loading = false;
            this.totalPages = response.pager.totalPages;
            this.totalItems = response.pager.totalItems;
            this.currentPage = response.pager.currentPage;
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateResaleOrders();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateResaleOrders();
    },
  },
};
</script>
